module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p3-0a493cc5022333e8ec740c58d74d3dae.png";